export default {
      id: "i-arrow-white-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-white",
      toString: function () {
        return this.url;
      }
    }